import { Link as LinkLi } from '@material-ui/core';
import { ArrowRightAlt } from '@material-ui/icons';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { findAndDeleteParentInJson, hasEnabledFeature, hasEnabledSettings, isInsuracePortalUser } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Alerts from './Alerts';
import DriverBehavior from './DriverBehavior';
import DriverStatus from './DriverStatus';
import Notifications from './Notfications';
import Overview from './Overview';
import PotentialViolations from './PotentialViolations';
import RadiusComplianceAlerts from './RadiusComplianceAlerts';
import RecentAccidents from './RecentAccidents';
import { driverStatusTableColumns, getELDStatusIcon } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const CsaViolation = lazy(() => import(`./CSASnapshot`));

const Component = ({
  i18n,
  Styled,
  history,
  dashboard,
  viewReport,
  getDriverStatus,
  getVehicleStatus,
  callback,
  dataList,
  handleDeleteAlert,
}) => {
  const insuracePortalUserRole = isInsuracePortalUser();
  const SERVICE_PROVIDER = window.$environment?.SERVICE_PROVIDER;
  const [value, setValue] = useState(0);
  const [sourceToDisplay, setSourceToDisplay] = useState([]);
  const [sourceList, setSourceList] = useState(dataList || []);
  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (!hasEnabledFeature('smoothTrackingEnabled')) {
      if (!hasEnabledFeature('geometrisEnabled') && !insuracePortalUserRole) {
        getDriverStatus({
          apiId: 'getDriverStatus',
          data: { isDashboard: true },
        });
      } else {
        getVehicleStatus({ apiId: 'getVehicleStatus' });
      }
      const interval = setInterval(() => {
        if (!hasEnabledFeature('geometrisEnabled') && !insuracePortalUserRole) {
          getDriverStatus({
            apiId: 'refreshDashboardMap',
            data: { isDashboard: true },
          });
        } else {
          getVehicleStatus({ apiId: 'refreshDashboardMap' });
        }
      }, 10000);
      return () => clearInterval(interval);
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (
      window.$environment?.clutchNewUI ||
      checkServiceProvider('overrideComp_findAndDeleteParentInJson', SERVICE_PROVIDER, false)
    ) {
      let data = dataList;
      if (!hasEnabledFeature('csaViolationFieldWaitingEnabled')) {
        data = findAndDeleteParentInJson(data, 'id', 'csaViolationFieldWaitingEnabled');
      }
      if (!hasEnabledFeature('accidentWebEnabled')) {
          data = findAndDeleteParentInJson(data, 'dependency', 'accidentWebEnabled');
      }
      setSourceList(data);
    }
  }, []);

  const driverStatus = () => (
    <Styled.DriverDashboard>
      <div className="dashboardComponents dashboardDriver">
        <div className="headingsWrapper">
          <span className="mainHeading">{i18n.t('dashboard.tabs.driverStatus.heading')}</span>
          <LinkLi
            component={Link}
            to={pageUrls.driverStatusViewMore}
            className="viewAll"
            onClick={() => history.push(pageUrls.driverStatusViewMore)}
          >
            {i18n.t('View All')}
            <ArrowRightAlt color="secondary" />
          </LinkLi>
        </div>
        <DriverStatus
          driverStatus={
            (hasEnabledFeature('geometrisEnabled') ? dashboard?.data?.driversOnDuty?.infoItems : dashboard?.driverStatusList) ||
            []
          }
          i18n={i18n}
          columns={hasEnabledFeature('geometrisEnabled') ? undefined : driverStatusTableColumns}
          generateRow={hasEnabledFeature('geometrisEnabled') ? undefined : generateRowDriverStatus}
        />
      </div>
    </Styled.DriverDashboard>
  );

  useEffect(() => {
    localStorage.setItem('daltnot', dashboard?.data?.enableNotification);
  }, [dashboard?.data?.enableNotification]);

  const getIdValue = (event) => {
    setNotificationEnabled(event);
    if (dashboard.data.enableNotification === false) {
      localStorage.setItem('daltnot', event);
      return true;
    } else if (dashboard.data.enableNotification === true && localStorage.getItem('daltnot') === 'true') {
      localStorage.setItem('daltnot', event);
      return false;
    } else {
      localStorage.setItem('daltnot', event);
      return true;
    }
  };

  const driverBehavior = () => (
    <Styled.DriverDashboard>
      <div className="dashboardComponents dashboardDriver driverBehaviour">
        <DriverBehavior i18n={i18n} history={history} callback={callback} />
      </div>
    </Styled.DriverDashboard>
  );

  const alerts = () => (
    <Styled.DriverDashboard>
      <div className="dashboardComponents dashboardDriver">
        <div className="headingsWrapper">
          <span className="mainHeading">{i18n.t('dashboard.tabs.alerts.heading')}</span>
          <LinkLi
            component={Link}
            to={pageUrls.alertViewMore}
            className="viewAll"
            onClick={() => history.push(pageUrls.alertViewMore)}
          >
            {i18n.t('View All')}
            <ArrowRightAlt color="secondary" />
          </LinkLi>
        </div>
        <Alerts
          list={dashboard.data?.alerts?.dashboardAlerts || []}
          handleDeleteAlert={handleDeleteAlert}
          callback={callback}
          i18n={i18n}
        />
      </div>
    </Styled.DriverDashboard>
  );

  const recentAccidents = () => (
    <>
      <Styled.DriverDashboard>
        <div className="dashboardComponents dashboardDriver">
          <div className="headingsWrapper">
            <span className="mainHeading">{i18n.t('dashboard.tabs.recentAccidents')}</span>
            <LinkLi
              component={Link}
              to={pageUrls.accidentsList}
              className="viewAll"
              onClick={() => history.push(pageUrls.accidentsList)}
            >
              {i18n.t('View All')}
              <ArrowRightAlt color="secondary" />
            </LinkLi>
          </div>
          <RecentAccidents
            i18n={i18n}
            recentAccidents={dashboard?.data?.recentAccidents?.infoItems || []}
            viewReport={viewReport}
          />
        </div>
      </Styled.DriverDashboard>
    </>
  );

  const radiusComplianceAlerts = () => (
    <Styled.DriverDashboard>
      <div className="dashboardComponents dashboardDriver">
        <div className="headingsWrapper">
          <span className="mainHeading">{i18n.t('dashboard.tabs.alerts.heading')}</span>
          <LinkLi
            component={Link}
            to={pageUrls.radiusComplianceAlertsViewMore}
            className="viewAll"
            onClick={() => history.push(pageUrls.radiusComplianceAlertsViewMore)}
          >
            {i18n.t('View All')}
            <ArrowRightAlt color="secondary" />
          </LinkLi>
        </div>
        <RadiusComplianceAlerts list={dashboard.insuranceData?.alerts || []} callback={callback} i18n={i18n} />
      </div>
    </Styled.DriverDashboard>
  );

  const overview = () => (
    <Styled.DriverDashboard>
      <div className="dashboardComponents dashboardDriver">
        <div className="headingsWrapper">
          <span className="mainHeading">{i18n.t('dashboard.tabs.overview')}</span>
          <LinkLi
            component={Link}
            to={pageUrls.fleetCompanies}
            className="viewAll"
            onClick={() => history.push(pageUrls.fleetCompanies)}
          >
            {i18n.t('View All')}
            <ArrowRightAlt color="secondary" />
          </LinkLi>
        </div>
        <Overview list={dashboard.insuranceData?.overviews || []} callback={callback} i18n={i18n} />
      </div>
    </Styled.DriverDashboard>
  );

  const potentialViolations = () => (
    <Styled.DriverDashboard>
      <div className="dashboardComponents dashboardDriver">
        <div className="headingsWrapper">
          <span className="mainHeading">{i18n.t('dashboard.tabs.potentialViolations.heading')}</span>
          <LinkLi
            component={Link}
            to={pageUrls.potentialViolationsViewMore}
            className="viewAll"
            onClick={() => history.push(pageUrls.potentialViolationsViewMore)}
          >
            {i18n.t('View All')}
            <ArrowRightAlt color="secondary" />
          </LinkLi>
        </div>
        <PotentialViolations i18n={i18n} potentialViolations={dashboard?.data?.driversAtRisk?.infoItems || []} />
      </div>
    </Styled.DriverDashboard>
  );

  const csaViolationFieldWaitingEnabled = () => <CsaViolation />;

  useEffect(() => {
    if (window.$environment?.clutchNewUI || checkServiceProvider('overrideComp_sourceToDisplay', SERVICE_PROVIDER, false)) {
      setNotificationEnabled(dashboard?.data?.enableNotification);
      const sourceToDisplay = sourceList.map((item) => {
        item.value = eval([item.id] + '()');
        item.name = (
          <>
            {item.icon && <SvgIcon className="svgIconStyle" value={mediaUrls[item?.icon]} />}
            <span>{i18n.t(item.nameKey)}</span>
          </>
        );
        return item;
      });
      if (checkServiceProvider('overrideComp_sourceToDisplay_filter', SERVICE_PROVIDER, false)) {
        let source = [];
        if (insuracePortalUserRole)
          source = sourceToDisplay.filter(
            (ele) =>
              ele.id !== 'alerts' && ele.id !== 'driverStatus' && ele.id !== 'potentialViolations' && ele.id !== 'driverBehavior'
          );
        else source = sourceToDisplay.filter((ele) => ele.id !== 'overview' && ele.id !== 'radiusComplianceAlerts');
        setSourceToDisplay(source);
      } else {
        setSourceToDisplay(sourceToDisplay);
      }
    }
  }, [
    dashboard.data,
    sourceList,
    dashboard?.data?.dailyLogs?.infoItems,
    dashboard?.data?.driversAtRisk?.infoItems,
    dashboard?.data?.recentAccidents?.infoItems,
    dashboard?.data?.enableNotification,
    notificationEnabled,
    dashboard?.insuranceData?.alerts,
    dashboard?.insuranceData?.overviews,
  ]);

  const generateRowDriverStatus = () => {
    const updatedList = dashboard?.driverStatusFilteredList.map((item, index) => {
      const rowItem = { ...item };
      rowItem.currentStatus = item.dailyLogId ? (
        <Icon
          src={mediaUrls?.logsIcon}
          tableicon
          onClick={() => history.push(pageUrls.logsView.replace(':id', item.dailyLogId))}
        ></Icon>
      ) : (
        '-'
      );
      rowItem.driveTimeRemaining = `${rowItem.driveTimeRemaining} hours`;
      rowItem.onDutyTimeRemaining = `${rowItem.onDutyTimeRemaining} hours`;
      rowItem.dutyCycleRemaining = `${rowItem.dutyCycleRemaining} hours`;
      if (checkServiceProvider('overrideComp_rowItem_eld', SERVICE_PROVIDER, false)) {
        rowItem.eld = (
          <a
            onClick={() => {
              if (rowItem.dailyLogUrl) history.push(rowItem.dailyLogUrl.replace('.', '/'));
              else setModal(true);
            }}
          >
            <div className={getELDStatusIcon(rowItem.eldState)} />
          </a>
        );
      }
      return rowItem;
    });
    return updatedList;
  };

  return (
    <Styled.Wrapper>
      {checkServiceProvider('overrideComp_googlemap', SERVICE_PROVIDER, false) && (
        <div className="mapSection">
          <GoogleMap
            type={'dashboardMap'}
            liveTracking={hasEnabledFeature('smoothTrackingEnabled')}
            height={'400px'}
            data={
              hasEnabledFeature('geometrisEnabled') || insuracePortalUserRole
                ? dashboard?.vehicleStatusList
                : dashboard?.driverStatusList
            }
            getDriverStatus={getDriverStatus}
            dashboard={dashboard}
            viewOnMap={null}
          />
        </div>
      )}
      {window?.$environment?.clutchNewUI || checkServiceProvider('overrideComp_Tab', SERVICE_PROVIDER, false) ? (
        <Tab data={sourceToDisplay} currentTab={value} onChange={handleChange} className="tabs" />
      ) : (
        <Styled.DriverDashboard fullWidth={hasEnabledSettings('HIDE_NOTIFICATION')}>
          <div className="dashboardComponents dashboardDriver">
            <div className="headingsWrapper">
              <span className="mainHeading">{i18n.t('dashboard.tabs.driverStatus.heading')}</span>
              <LinkLi
                component={Link}
                to={pageUrls.driverStatusViewMore}
                className="viewAll"
                onClick={() => history.push(pageUrls.driverStatusViewMore)}
              >
                {i18n.t('View All')}
                <ArrowRightAlt color="secondary" />
              </LinkLi>
            </div>
            <DriverStatus
              driverStatus={
                (hasEnabledFeature('geometrisEnabled')
                  ? dashboard?.data?.driversOnDuty?.infoItems
                  : dashboard?.driverStatusList) || []
              }
              i18n={i18n}
              columns={hasEnabledFeature('geometrisEnabled') ? undefined : driverStatusTableColumns}
              generateRow={hasEnabledFeature('geometrisEnabled') ? undefined : generateRowDriverStatus}
            />
          </div>
          {hasEnabledSettings('HIDE_NOTIFICATION') ? null : (
            <div className="dashboardComponents dashboardViolation">
              <div className="headingsWrapper">
                <span className="mainHeading">Notifications</span>
                <LinkLi
                  component={Link}
                  to={pageUrls.potentialViolationsViewMore}
                  className="viewAll"
                  onClick={() => history.push(pageUrls.potentialViolationsViewMore)}
                >
                  {i18n.t('View All')}
                  <ArrowRightAlt color="secondary" />
                </LinkLi>
              </div>
              <Notifications potentialViolations={dashboard?.data?.driversAtRisk?.infoItems || []} i18n={i18n} />
            </div>
          )}
        </Styled.DriverDashboard>
      )}
      {checkServiceProvider('overrideComp_driverBehavior', SERVICE_PROVIDER, false) && (
        <Styled.DriverDashboard>
          <div className="dashboardComponents dashboardDriver dashboardDriverBehaviour">
            <div className="headingsWrapper">
              <span className="mainHeading">{i18n.t('dashboard.tabs.driverBehavior')}</span>
            </div>
            <DriverBehavior i18n={i18n} history={history} callback={callback} />
          </div>
        </Styled.DriverDashboard>
      )}
      <Modal
        open={modal}
        setOpen={() => setModal((m) => !m)}
        withCloseIcon
        alignItemsLeft
        noDataPopup
        data={{
          header: '',
          content: () => <div>No Logs available</div>,
        }}
      />
    </Styled.Wrapper>
  );
};

export default Component;

Component.propTypes = {
  history: PropTypes.object.isRequired,
  potentialViolations: PropTypes.array.isRequired,
};
